
// product page
if($('.product-single').hasClass('vertical') || $('.product-single').hasClass('horizontal') || $('.product-single').hasClass('slider_grid') ) {
    let productImages = [];
    $('.product-photos-list-item').on('click', function () {
        let photoLink = $(this).find('.product-single__thumbnail').data('zoom');
        $('.lightbox-link').attr('href', photoLink);
        $('.product-photos-list-item').removeClass('active');
        $(this).addClass('active');
    });
    if ($('.product-photos-list-item a.product-single__thumbnail').length > 0) {
      
        $('.product-photos-list-item a.product-single__thumbnail').each(function () {
            productImages.push({
                id: $(this).data('position'),
                src: $(this).data('zoom')
            });
        });
      	
      setTimeout(function () {
      for (let i = 0; i < productImages.length; i++) {
                if (productImages[i]['id'] === 0) {
                    newImages = productImages.slice(i, productImages.length);
                    productImages.splice(i, productImages.length - i);
                    productImages.unshift(...newImages);
                }
            }
            

        $('.lightbox-link').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true,
//                 navigateByImgClick: true,
            },
            items: productImages
        });
      }, 500);

        $('.product-single__thumbnail img').on('click', function () {
            let pos = $(this).parent().data('position');
            let urlZoom = $(this).parent().data('zoom');
            let newImages = [];
            for (let i = 0; i < productImages.length; i++) {
                if (productImages[i]['id'] === pos) {
                    newImages = productImages.slice(i, productImages.length);
                    productImages.splice(i, productImages.length - i);
                    productImages.unshift(...newImages);
                }
            }
          

            $('.lightbox-link').magnificPopup({
                type: 'image',
                gallery: {
                    enabled: true
                },
                items: productImages
            });
            $('#ProductPhotoImg').attr('data-zoom-image', $('#ProductPhotoImg').attr('src'));
            $('.zoomImg').attr('src', $(this).attr('zoom-src'));
        });
    }
}


var window_scroll_bottom = 0;
if( $('.product-single').hasClass('without_slider') ) {
    var fixed_height;
    if ($('.fixed_menu').height()) {
        fixed_height = $('.fixed_menu').height();
    } else {
        fixed_height = 0;
    }
    let windowHeight = $(window).height() - fixed_height;
    let product_left_scroll_bottom = 0;
    let top_part = fixed_height;
    let fp_scroll_bottom = 0;
    $('.without_slider .product-right').removeClass('glued');
    $(window).on('scroll resize', function () {
        if ($(window).outerWidth() > 767) {

            window_scroll_bottom = $(this).scrollTop() + $(this).height();
            if ($(this).scrollTop() > $('.header').height() && !$('.product-right .fixed_part').hasClass('glued')) {
                $('.product-right .fixed_part').addClass('scroll');
                $('.product-right .fixed_part').css({
                    'top': top_part,
                    "width": $(".without_slider .product-right").width()
                });
            } else {
                $('.product-right .fixed_part').removeClass('scroll');
            }
            product_left_scroll_bottom = $(".without_slider .product-left").offset().top + $(".without_slider .product-left").height();
            fp_scroll_bottom = $('.product-right .fixed_part').offset().top + $('.product-right .fixed_part').height();
            if (product_left_scroll_bottom < fp_scroll_bottom) {
                $('.product-right .fixed_part').removeClass('scroll');
                $('.without_slider .product-right').addClass('glued');
            } else {
                $('.without_slider .product-right').removeClass('glued');
            }

        } else {
            $('.product-right .fixed_part').removeClass('scroll');
            $('.product-right .fixed_part').css({
                'top': 'auto',
                'width': '100%'
            });
        }
    });
}

if( $('.product-single').hasClass('slider_grid') ) {
    $('.product-photos-list-item:not(.grid-item)').on('click', function () {
        let image_id = $(this).data('image-id');
        let pos = $('.product_layout_slider').find('.product-image-item[data-image-id="' + image_id + '"]').data('position');

        setTimeout(function () {
            $('.product_layout_slider').trigger('to.owl.carousel', [pos, 300]);
        }, 100);
    });
}